import script from "./TableSkeletonLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./TableSkeletonLoader.vue?vue&type=script&setup=true&lang=js"

import "./TableSkeletonLoader.vue?vue&type=style&index=0&id=2a7c2069&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a7c2069"]])

export default __exports__